<template>
  <v-container-np class="bg-primary">
    <v-container-restricted-pt
      style="max-width: 1500px !important"
      class="d-flex flex-column justify-center text-center pb-2 pb-sm-5 hero-container"
    >
      <v-row align="center" class="py-16 py-md-0">
        <v-col cols="12" md="6" align="center">
          <v-container-np class="hero-text text-md-left text-center">
            <p class="text-h6 text-sm-h5 text-md-h4">
              Fashion Forward, an innovative online fashion retailer
            </p>
            <v-container class="py-3 px-0">
              <p class="text-subtitle-1 font-weight-medium">
                Industry
                <span class="text-subtitle-2 font-weight-regular"
                  >E-commerce, Fashion</span
                >
              </p>
              <p class="text-subtitle-1 font-weight-medium">
                Location
                <span class="text-subtitle-2 font-weight-regular"
                  >New York, USA</span
                >
              </p>
            </v-container>
            <p class="text-h6">Objective</p>
            <p class="text-subtitle-1">
              To enhance the online shopping experience by integrating a virtual
              try-on feature, enabling customers to see how clothes would look
              on them before making a purchase.
            </p>
          </v-container-np>
        </v-col>
        <v-col cols="6" class="d-none d-md-flex hero-image">
          <img width="100%" src="~/assets/images/vto-case-study-hero-img.png" />
        </v-col>
      </v-row>
    </v-container-restricted-pt>
  </v-container-np>
</template>
<script lang="ts" setup></script>
<style scoped>
@keyframes heroImageAnimation {
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

@keyframes heroTextAnimation {
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
@keyframes heroBtnAnimation {
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}

.hero-image {
  opacity: 0;
  transform: translateX(-30px);
  animation: 2s heroImageAnimation forwards ease;
}

.hero-text {
  opacity: 0;
  transform: translateY(-30px);
  animation: 1s heroTextAnimation forwards ease;
}

.hero-btn {
  opacity: 0;
  transform: translateY(30px);
  animation: 1s heroBtnAnimation forwards ease;
}

@media screen and (max-width: 960px) {
  .hero-container {
    background: linear-gradient(
        rgba(var(--v-theme-primary), 0.6),
        rgba(var(--v-theme-primary), 0.6)
      ),
      url("~/assets/images/vto-case-study-hero-img.png") center no-repeat;
    background-size: contain;
  }
}
</style>
